define('shared/remote/payment/adyen/update/constructSessionPayload',[
    'shared/my/cmus'
], function (
    getCMus
) {

    return function () {
        return getCMus()
            .then(function(cmus){
                return {
                    'cmus': cmus,
                    'gatewayType': 'AdyenEL',
                    'extraInfo': {
                        'adyenOrigin': window.location.origin,
                        'adyenSdkVersion': '1.9.2',
                        'returnUrl': window.location.origin + window.location.pathname,
                    }
            };
        });
    }
});

